const translations = {
    "pl": {
        "nav_product": "Produkty",
        "nav_specs": "Specyfikacja",
        "nav_pro": "Extra Strong",
        "nav_dist": "Kontakt",
        "nav_contact": "Kontakt",
        "hero_badge": "Rewolucja w montażu",
        "hero_title_1": "Jeden klips.",
        "hero_title_2": "Wiele możliwości.",
        "hero_subtitle": "Proste, błyskawiczne i bezinwazyjne mocowanie przewodów. Pozbądź się śrub, kołków i kleju na zawsze.",
        "hero_cta_buy": "Złóż zamówienie",
        "shipping_info": "Dostawa w 24h • Kurier GLS",
        "features_title": "Zaprojektowane dla profesjonalistów",
        "features_subtitle": "Mniej narzędzi. Szybsza praca. Idealne dopasowanie.",
        "feat_1_title": "Uniwersalny rozmiar",
        "feat_1_desc": "Od 22 mm do 50 mm. Jeden innowacyjny klips zastępuje cały arsenał tradycyjnych rozwiązań dla kanałów i rur.",
        "feat_2_title": "Oszczędność czasu",
        "feat_2_desc": "Wkładasz w szczelinę i gotowe. Bez wkrętów.",
        "feat_3_title": "100% Produkcja w Danii",
        "feat_3_desc": "Gwarancja najwyższej jakości wykonania.",
        "feat_4_title": "Materiały z recyklingu",
        "feat_4_desc": "Stworzone z wyjątkowo trwałego tworzywa PP z recyklingu.",
        "quote_text": "\"W końcu nie muszę nosić kilku różnych klipsów. Jeden produkt pasuje do wszystkiego.\"",
        "quote_author": "— Jerzy P., Instalator",
        "specs_title": "Specyfikacja.",
        "specs_subtitle": "Liczy się każdy detal.",
        "spec_range": "Zakres",
        "spec_material": "Materiał",
        "spec_material_val": "Tworzywo PP (Recykling)",
        "spec_use": "Zastosowanie",
        "spec_use_val": "Przewody, rury, rury PEX",
        "spec_pkg": "Opakowanie",
        "spec_pkg_val": "50-100 szt. (torba strunowa)",
        "specs_desc": "Wystarczy obrócić klips. Niezależnie od tego czy pracujesz w wąskim czy szerokim kanale, DuoClips dopasowuje się błyskawicznie.",
        "hd_badge": "Extra Strong",
        "hd_title": "DuoClips <span class=\"brand-text-orange\">ORANGE</span> - EXTRA STRONG",
        "hd_subtitle": "Zaprojektowane do zadań specjalnych. Maksymalna wytrzymałość, gdy standard to za mało.",
        "hd_feat_1": "Mocniejszy materiał",
        "hd_feat_2": "Szybka instalacja",
        "hd_feat_3": "Wytrzymały chwyt",
        "hd_feat_4": "Działa z przewodami, rurami",
        "hd_feat_5": "Dla elektryków i hydraulików",
        "hd_overlay": "Przewiń po premierze",
        "form_name": "Imię i nazwisko / Firma",
        "form_placeholder_name": "Jan Kowalski",
        "form_email": "Adres e-mail",
        "form_placeholder_email": "kontakt@firma.pl",
        "form_phone": "Numer telefonu (opcjonalnie)",
        "form_placeholder_phone": "+48 000 000 000",
        "form_terms": "Akceptuję <a href=\"#\">Regulamin</a> i <a href=\"#\">Politykę prywatności</a>.",
        "form_consent": "Zgoda na kontakt w celach handlowych.",
        "form_submit": "Wyślij zapytanie",
        "form_success": "Wiadomość została wysłana. Dziękujemy!",
        "footer_brand_desc": "Przyszłość profesjonalnego mocowania.",
        "footer_contact_title": "Kontakt B2B",
        "footer_work_hours": "Pon. - Pt. 8:00 - 16:00",
        "footer_privacy": "Polityka Prywatności",
        "review_title": "Przydatne i łatwe w użyciu!",
        "review_text": "Idealny produkt, wreszcie coś, co sprawdza się w prawdziwych warunkach pracy!!",
        "review_author": "Klient Amazon",
        "review_verified": "✓ Zweryfikowany zakup",
        "review_date": "Zrecenzowano w Niemczech, 3 maja 2026 r.",
        "footer_terms": "Regulamin Sklepu",
        "footer_copyright": "&copy; 2026 SCROBER®. Wszelkie prawa zastrzeżone.",
        "cart_title": "Twój koszyk",
        "cart_empty": "Twój koszyk jest pusty",
        "cart_total": "Suma:",
        "cart_checkout": "Przejdź do kasy",
        "coll_add_to_cart": "Do koszyka",
        "coll_empty": "Brak produktów w kolekcji.",
        "coll_sold_out": "Wyprzedane",
        "form_message": "Wiadomość",
        "form_placeholder_message": "Jak możemy Ci pomóc?",
        "pro_cta_buy": "Kup Teraz",
        "prod_add_to_cart": "Do koszyka",
        "prod_quantity_label": "Ilość",
        "prod_sold_out": "Wyprzedane",
        "prod_variant_label": "Wariant",
        "cart_shipping_free": "Masz bezpłatną dostawę!",
        "cart_shipping_missing_pre": "Brakuje",
        "cart_shipping_missing_post": "do bezpłatnej dostawy!",
        "cart_error": "Wyst\u0105pi\u0142 b\u0142\u0105d podczas dodawania do koszyka.",
        "lang_pl": "Polski",
        "lang_en": "English (UK)",
        "lang_de": "Deutsch",
        "lang_fr": "Fran\u00e7ais",
        "lang_es": "Espa\u00f1ol",
        "lang_cs": "\u010ce\u0161tina",
        "lang_sl": "Sloven\u0161\u010dina",
        "spec_range_val": "22 \u2013 50 mm"
    },
    "en": {
        "nav_product": "Products",
        "nav_specs": "Specs",
        "nav_pro": "Extra Strong",
        "nav_dist": "Contact",
        "nav_contact": "Contact",
        "hero_badge": "Revolution in mounting",
        "hero_title_1": "One clip.",
        "hero_title_2": "Many possibilities.",
        "hero_subtitle": "Simple, lightning-fast and non-invasive wire mounting. Get rid of screws, pegs and glue forever.",
        "hero_cta_buy": "Order Now",
        "shipping_info": "Delivery in 24h • GLS Courier",
        "features_title": "Designed for professionals",
        "features_subtitle": "Fewer tools. Faster work. Perfect fit.",
        "feat_1_title": "Universal size",
        "feat_1_desc": "From 22 mm to 50 mm. One innovative clip replaces an entire arsenal of traditional solutions for ducts and pipes.",
        "feat_2_title": "Time saving",
        "feat_2_desc": "Just insert into the gap and it's done. Without screws.",
        "feat_3_title": "100% Made in Denmark",
        "feat_3_desc": "Guarantee of the highest quality workmanship.",
        "feat_4_title": "Recycled materials",
        "feat_4_desc": "Made from extremely durable recycled PP material.",
        "quote_text": "\"Finally, I don't have to carry several different clips. One product fits everything.\"",
        "quote_author": "— George P., Installer",
        "specs_title": "Specifications.",
        "specs_subtitle": "Every detail counts.",
        "spec_range": "Range",
        "spec_material": "Material",
        "spec_material_val": "PP Plastic (Recycled)",
        "spec_use": "Application",
        "spec_use_val": "Wires, pipes, PEX pipes",
        "spec_pkg": "Packaging",
        "spec_pkg_val": "100 pcs. (zip-lock bag)",
        "specs_desc": "Just turn the clip. Whether you're working in a narrow or wide duct, DuoClips adjusts instantly.",
        "hd_badge": "Extra Strong",
        "hd_title": "DuoClips <span class=\"brand-text-orange\">ORANGE</span> - EXTRA STRONG",
        "hd_subtitle": "Designed for special tasks. Maximum strength when standard is not enough.",
        "hd_feat_1": "Stronger material",
        "hd_feat_2": "Fast installation",
        "hd_feat_3": "Strong grip",
        "hd_overlay": "Scroll after premiere",
        "dist_title": "Contact Us",
        "form_name": "Name / Company",
        "form_placeholder_name": "John Doe",
        "form_email": "E-mail address",
        "form_placeholder_email": "contact@company.com",
        "form_phone": "Phone number (optional)",
        "form_placeholder_phone": "+44 000 000 000",
        "form_terms": "I accept the <a href=\"#\">Terms and Conditions</a> and <a href=\"#\">Privacy Policy</a>.",
        "form_consent": "I consent to be contacted for commercial purposes.",
        "form_submit": "Send inquiry",
        "form_success": "Message sent. Thank you!",
        "footer_brand_desc": "The future of professional mounting.",
        "footer_contact_title": "B2B Contact",
        "footer_work_hours": "Mon - Fri 8:00 AM - 4:00 PM",
        "footer_privacy": "Privacy Policy",
        "review_title": "Useful and easy to use!",
        "review_text": "Perfect product, finally something that is usable in real working conditions!!",
        "review_author": "Amazon Customer",
        "review_verified": "✓ Verified Purchase",
        "review_date": "Reviewed in Germany on 3 May 2026",
        "footer_terms": "Terms of Service",
        "footer_copyright": "&copy; 2026 SCROBER®. All rights reserved.",
        "hd_feat_4": "Works with cables and pipes",
        "hd_feat_5": "For electricians and plumbers",
        "cart_title": "Your Cart",
        "cart_empty": "Your cart is empty",
        "cart_total": "Total:",
        "cart_checkout": "Checkout",
        "coll_add_to_cart": "Add to cart",
        "coll_empty": "No products in collection.",
        "coll_sold_out": "Sold out",
        "form_message": "Message",
        "form_placeholder_message": "How can we help you?",
        "pro_cta_buy": "Buy Now",
        "prod_add_to_cart": "Add to cart",
        "prod_quantity_label": "Quantity",
        "prod_sold_out": "Sold out",
        "prod_variant_label": "Variant",
        "cart_shipping_free": "You have free shipping!",
        "cart_shipping_missing_pre": "You are",
        "cart_shipping_missing_post": "away from free shipping!"
    },
    "de": {
        "nav_product": "Produkt",
        "nav_specs": "Spezifikationen",
        "nav_pro": "Extra Strong",
        "nav_dist": "Kontakt",
        "nav_contact": "Kontakt",
        "hero_badge": "Revolution in der Montage",
        "hero_title_1": "Ein Clip.",
        "hero_title_2": "Viele Möglichkeiten.",
        "hero_subtitle": "Einfache, blitzschnelle und zerstörungsfreie Kabelmontage. Befreien Sie sich für immer von Schrauben, Dübeln und Kleber.",
        "hero_cta_buy": "Jetzt bestellen",
        "shipping_info": "Lieferung in 24h • GLS Kurier",
        "features_title": "Entwickelt für Profis",
        "features_subtitle": "Weniger Werkzeuge. Schnelleres Arbeiten. Perfekte Passform.",
        "feat_1_title": "Universelle Größe",
        "feat_1_desc": "Von 22 mm bis 50 mm. Ein innovativer Clip ersetzt ein ganzes Arsenal herkömmlicher Lösungen für Kanäle und Rohre.",
        "feat_2_title": "Zeitersparnis",
        "feat_2_desc": "Einfach in den Schlitz stecken und fertig. Ohne Schrauben.",
        "feat_3_title": "100% Hergestellt in Dänemark",
        "feat_3_desc": "Garantie für höchste Verarbeitungsqualität.",
        "feat_4_title": "Recycelte Materialien",
        "feat_4_desc": "Hergestellt aus extrem langlebigem recyceltem PP-Material.",
        "quote_text": "\"Endlich muss ich nicht mehr verschiedene Clips mitschleppen. Ein Produkt passt für alles.\"",
        "quote_author": "— Georg P., Installateur",
        "specs_title": "Spezifikationen.",
        "specs_subtitle": "Jedes Detail zählt.",
        "spec_range": "Bereich",
        "spec_material": "Material",
        "spec_material_val": "PP-Kunststoff (Recycelt)",
        "spec_use": "Anwendung",
        "spec_use_val": "Drähte, Rohre, PEX-Rohre",
        "spec_pkg": "Verpackung",
        "spec_pkg_val": "100 Stk. (Druckverschlussbeutel)",
        "specs_desc": "Drehen Sie einfach den Clip. Egal, ob Sie in einem engen oder weiten Kanal arbeiten, DuoClips passt sich sofort an.",
        "hd_badge": "Extra Strong",
        "hd_title": "DuoClips <span class=\"brand-text-orange\">ORANGE</span> - EXTRA STRONG",
        "hd_subtitle": "Entwickelt für besondere Aufgaben. Maximale Festigkeit, wenn Standard nicht ausreicht.",
        "hd_feat_1": "Stärkeres Material",
        "hd_feat_2": "Schnelle Installation",
        "hd_feat_3": "Starker Halt",
        "hd_overlay": "Nach der Premiere scrollen",
        "dist_title": "Kontaktiere uns",
        "dist_subtitle": "Haben Sie Fragen? Möchten Sie zusammenarbeiten? Füllen Sie das untenstehende Formular aus.",
        "form_name": "Name / Firma",
        "form_placeholder_name": "Max Mustermann",
        "form_email": "E-Mail-Adresse",
        "form_placeholder_email": "kontakt@firma.de",
        "form_phone": "Telefonnummer (optional)",
        "form_placeholder_phone": "+49 000 000 000",
        "form_terms": "Ich akzeptiere die <a href=\"#\">AGB</a> und <a href=\"#\">Datenschutzerklärung</a>.",
        "form_consent": "Ich stimme der Kontaktaufnahme zu kommerziellen Zwecken zu.",
        "form_submit": "Anfrage senden",
        "form_success": "Nachricht gesendet. Vielen Dank!",
        "footer_brand_desc": "Die Zukunft der professionellen Befestigung.",
        "footer_contact_title": "B2B-Kontakt",
 
        "footer_privacy": "Datenschutz",
        "review_title": "Nützlich und einfach zu bedienen!",
        "review_text": "Perfektes Produkt, endlich etwas, das unter echten Arbeitsbedingungen brauchbar ist!!",
        "review_author": "Amazon-Kunde",
        "review_verified": "✓ Verifizierter Kauf",
        "review_date": "Rezension aus Deutschland vom 3. Mai 2026",
        "footer_terms": "AGB",
        "footer_copyright": "&copy; 2026 SCROBER®. Alle Rechte vorbehalten.",
        "hd_feat_4": "Für Kabel und Rohre",
        "hd_feat_5": "Für Elektriker und Klempner",
        "cart_title": "Ihr Warenkorb",
        "cart_empty": "Ihr Warenkorb ist leer",
        "cart_total": "Summe:",
        "cart_checkout": "Zur Kasse",
        "coll_add_to_cart": "In den Warenkorb",
        "coll_empty": "Keine Produkte in der Kollektion.",
        "coll_sold_out": "Ausverkauft",
        "form_message": "Nachricht",
        "form_placeholder_message": "Wie können wir Ihnen helfen?",
        "pro_cta_buy": "Jetzt kaufen",
        "prod_add_to_cart": "In den Warenkorb",
        "prod_quantity_label": "Menge",
        "prod_sold_out": "Ausverkauft",
        "prod_variant_label": "Variante",
        "cart_shipping_free": "Sie haben kostenlosen Versand!",
        "cart_shipping_missing_pre": "Noch",
        "cart_shipping_missing_post": "bis zum kostenlosen Versand!"
    },
    "fr": {
        "nav_product": "Produit",
        "nav_specs": "Spécifications",
        "nav_pro": "Extra Strong",
        "nav_dist": "Contact",
        "nav_contact": "Contact",
        "hero_badge": "Révolution de montage",
        "hero_title_1": "Un clip.",
        "hero_title_2": "Beaucoup de possibilités.",
        "hero_subtitle": "Montage de fils simple, ultra-rapide et non invasif. Débarrassez-vous des vis, chevilles et colles.",
        "hero_cta_buy": "Commander",
        "shipping_info": "Livraison en 24h • GLS",
        "features_title": "Conçu pour les professionnels",
        "features_subtitle": "Moins d'outils. Travail plus rapide. Ajustement parfait.",
        "feat_1_title": "Taille universelle",
        "feat_1_desc": "De 22 mm à 50 mm. Un clip remplace un arsenal de solutions traditionnelles.",
        "feat_2_title": "Gain de temps",
        "feat_2_desc": "Il suffit de l'insérer dans la fente et c'est fait. Sans vis.",
        "feat_3_title": "100% Fabriqué au Danemark",
        "feat_3_desc": "Garantie d'une qualité de fabrication supérieure.",
        "feat_4_title": "Matériaux recyclés",
        "feat_4_desc": "Fabriqué à partir de matériau PP recyclé extrêmement durable.",
        "quote_text": "\"Enfin, je n'ai plus besoin de porter différents clips. Un seul produit s'adapte à tout.\"",
        "quote_author": "— Georges P., Installateur",
        "specs_title": "Spécifications.",
        "specs_subtitle": "Chaque détail compte.",
        "spec_range": "Gamme",
        "spec_material": "Matériau",
        "spec_material_val": "Plastique PP (Recyclé)",
        "spec_use": "Application",
        "spec_use_val": "Fils, tuyaux, tuyaux PEX",
        "spec_pkg": "Emballage",
        "spec_pkg_val": "100 pcs (sac zip)",
        "specs_desc": "Il suffit de tourner le clip. Que vous travailliez dans un conduit étroit ou large, DuoClips s'adapte instantanément.",
        "hd_badge": "Extra Strong",
        "hd_title": "DuoClips <span class=\"brand-text-orange\">ORANGE</span> - EXTRA STRONG",
        "hd_subtitle": "Conçu pour des tâches spéciales. Résistance maximale quand le standard ne suffit pas.",
        "hd_feat_1": "Matériau plus solide",
        "hd_feat_2": "Installation rapide",
        "hd_feat_3": "Prise solide",
        "hd_overlay": "Défiler après la première",
        "dist_title": "Contactez-nous",
        "dist_subtitle": "Vous avez des questions ? Vous souhaitez collaborer ? Remplissez le formulaire ci-dessous.",
        "form_name": "Nom / Entreprise",
        "form_placeholder_name": "Jean Dupont",
        "form_email": "Adresse e-mail",
        "form_placeholder_email": "contact@entreprise.fr",
        "form_phone": "Numéro de téléphone (optionnel)",
        "form_placeholder_phone": "+33 0 00 00 00 00",
        "form_terms": "J'accepte les <a href=\"#\">Conditions Générales</a> et la <a href=\"#\">Politique de Confidentialité</a>.",
        "form_consent": "J'accepte d'être contacté à des fins commerciales.",
        "form_submit": "Envoyer la demande",
        "form_success": "Message envoyé. Merci !",
        "footer_brand_desc": "L'avenir de la fixation professionnelle.",
        "footer_contact_title": "Contact B2B",
        "footer_work_hours": "Lun - Ven 8h00 - 16h00",
        "footer_privacy": "Politique de confidentialité",
        "review_title": "Utile et facile à utiliser !",
        "review_text": "Produit parfait, enfin quelque chose d'utilisable dans de vraies conditions de travail !!",
        "review_author": "Client Amazon",
        "review_verified": "✓ Achat vérifié",
        "review_date": "Évalué en Allemagne le 3 mai 2026",
        "footer_terms": "Conditions d'utilisation",
        "footer_copyright": "&copy; 2026 SCROBER®. Tous droits réservés.",
        "hd_feat_4": "Pour câbles et tuyaux",
        "hd_feat_5": "Pour électriciens et plombiers",
        "cart_title": "Votre panier",
        "cart_empty": "Votre panier est vide",
        "cart_total": "Total :",
        "cart_checkout": "Passer à la caisse",
        "coll_add_to_cart": "Ajouter au panier",
        "coll_empty": "Aucun produit dans la collection.",
        "coll_sold_out": "Épuisé",
        "form_message": "Message",
        "form_placeholder_message": "Comment pouvons-nous vous aider ?",
        "pro_cta_buy": "Acheter",
        "prod_add_to_cart": "Ajouter au panier",
        "prod_quantity_label": "Quantité",
        "prod_sold_out": "Épuisé",
        "prod_variant_label": "Variante",
        "cart_shipping_free": "Vous bénéficiez de la livraison gratuite !",
        "cart_shipping_missing_pre": "Il vous manque",
        "cart_shipping_missing_post": "pour la livraison gratuite !"
    },
    "es": {
        "nav_product": "Producto",
        "nav_specs": "Especificaciones",
        "nav_pro": "Extra Strong",
        "nav_dist": "Contacto",
        "nav_contact": "Contacto",
        "hero_badge": "Revolución en montaje",
        "hero_title_1": "Un clip.",
        "hero_title_2": "Múltiples posibilidades.",
        "hero_subtitle": "Montaje de cables sencillo, ultrarrápido y no invasivo. Deshazte de tornillos, tacos y pegamento para siempre.",
        "hero_cta_buy": "Hacer pedido",
        "shipping_info": "Entrega en 24h • GLS",
        "features_title": "Diseñado para profesionales",
        "features_subtitle": "Menos herramientas. Trabajo más rápido. Ajuste perfecto.",
        "feat_1_title": "Tamaño universal",
        "feat_1_desc": "De 22 mm a 50 mm. Un clip innovador reemplaza todo un arsenal de soluciones tradicionales.",
        "feat_2_title": "Ahorro de tiempo",
        "feat_2_desc": "Simplemente insértelo en la ranura y listo. Sin tornillos.",
        "feat_3_title": "100% Fabricado en Dinamarca",
        "feat_3_desc": "Garantía de mano de obra de la más alta calidad.",
        "feat_4_title": "Materiales reciclados",
        "feat_4_desc": "Fabricado con material de PP reciclado extremadamente duradero.",
        "quote_text": "\"Por fin no tengo que llevar varios clips diferentes. Un producto sirve para todo.\"",
        "quote_author": "— Jorge P., Instalador",
        "specs_title": "Especificaciones.",
        "specs_subtitle": "Cada detalle cuenta.",
        "spec_range": "Rango",
        "spec_material": "Material",
        "spec_material_val": "Plástico PP (Reciclado)",
        "spec_use": "Aplicación",
        "spec_use_val": "Cables, tuberías, tuberías PEX",
        "spec_pkg": "Embalaje",
        "spec_pkg_val": "100 ud (bolsa zip)",
        "specs_desc": "Simplemente gire el clip. Ya sea que trabaje en un conducto estrecho o ancho, DuoClips se ajusta instantáneamente.",
        "hd_badge": "Extra Strong",
        "hd_title": "DuoClips <span class=\"brand-text-orange\">ORANGE</span> - EXTRA STRONG",
        "hd_subtitle": "Diseñado para tareas especiales. Máxima resistencia cuando el estándar no es suficiente.",
        "hd_feat_1": "Material más fuerte",
        "hd_feat_2": "Instalación rápida",
        "hd_feat_3": "Agarre fuerte",
        "hd_overlay": "Desplazar después del estreno",
        "dist_title": "Contáctenos",
        "dist_subtitle": "¿Tiene preguntas? ¿Quiere colaborar? Complete el formulario a continuación.",
        "form_name": "Nombre / Empresa",
        "form_placeholder_name": "Juan Pérez",
        "form_email": "Correo electrónico",
        "form_placeholder_email": "contacto@empresa.es",
        "form_phone": "Teléfono (opcional)",
        "form_placeholder_phone": "+34 000 000 000",
        "form_terms": "Acepto los <a href=\"#\">Términos y Condiciones</a> y la <a href=\"#\">Política de Privacidad</a>.",
        "form_consent": "Doy mi consentimiento para ser contactado con fines comerciales.",
        "form_submit": "Enviar consulta",
        "form_success": "Mensaje enviado. ¡Gracias!",
        "footer_brand_desc": "El futuro del montaje profesional.",
        "footer_contact_title": "Contacto B2B",
        "footer_work_hours": "Lun - Vie 8:00 - 16:00",
        "footer_privacy": "Política de privacidad",
        "review_title": "¡Útil y fácil de usar!",
        "review_text": "¡Producto perfecto, por fin algo que se puede usar en condiciones reales de trabajo!",
        "review_author": "Cliente de Amazon",
        "review_verified": "✓ Compra verificada",
        "review_date": "Revisado en Alemania el 3 de mayo de 2026",
        "footer_terms": "Términos de servicio",
        "footer_copyright": "&copy; 2026 SCROBER®. Todos los derechos reservados.",
        "hd_feat_4": "Para cables y tuberías",
        "hd_feat_5": "Para electricistas y fontaneros",
        "cart_title": "Tu carrito",
        "cart_empty": "Tu carrito está vacío",
        "cart_total": "Total:",
        "cart_checkout": "Pasar por caja",
        "coll_add_to_cart": "Añadir al carrito",
        "coll_empty": "No hay productos en la colección.",
        "coll_sold_out": "Agotado",
        "form_message": "Mensaje",
        "form_placeholder_message": "¿Cómo podemos ayudarte?",
        "pro_cta_buy": "Comprar ahora",
        "prod_add_to_cart": "Añadir al carrito",
        "prod_quantity_label": "Cantidad",
        "prod_sold_out": "Agotado",
        "prod_variant_label": "Variante",
        "cart_shipping_free": "¡Tienes envío gratis!",
        "cart_shipping_missing_pre": "¡Te faltan",
        "cart_shipping_missing_post": "para el envío gratis!"
    },
    "cs": {
        "nav_product": "Produkt",
        "nav_specs": "Specifikace",
        "nav_pro": "Extra Strong",
        "nav_dist": "Kontakt",
        "nav_contact": "Kontakt",
        "hero_badge": "Revoluce v montáži",
        "hero_title_1": "Jeden klip.",
        "hero_title_2": "Mnoho možností.",
        "hero_subtitle": "Jednoduchá, blesková a neinvazivní montáž kabelů. Zbavte se šroubů, hmoždinek a lepidla navždy.",
        "hero_cta_buy": "Objednat nyní",
        "shipping_info": "Doručení do 24h • Kurýr GLS",
        "features_title": "Navrženo pro profesionály",
        "features_subtitle": "Méně nástrojů. Rychlejší práce. Perfektní střih.",
        "feat_1_title": "Univerzální velikost",
        "feat_1_desc": "Od 22 mm do 50 mm. Jeden inovativní klip nahrazuje celý arzenál tradičních řešení.",
        "feat_2_title": "Úspora času",
        "feat_2_desc": "Stačí vložit do štěrbiny a je hotovo. Bez šroubů.",
        "feat_3_title": "100% Vyrobeno v Dánsku",
        "feat_3_desc": "Záruka nejvyšší kvality zpracování.",
        "feat_4_title": "Recyklované materiály",
        "feat_4_desc": "Vyrobeno z extrémně odolného recyklovaného PP materiálu.",
        "quote_text": "\"Konečně s sebou nemusím nosit několik různých klipů. Jeden produkt se hodí na všechno.\"",
        "quote_author": "— Jiří P., Instalatér",
        "specs_title": "Specifikace.",
        "specs_subtitle": "Záleží na každém detailu.",
        "spec_range": "Rozsah",
        "spec_material": "Materiál",
        "spec_material_val": "PP Plast (Recyklovaný)",
        "spec_use": "Použití",
        "spec_use_val": "Kabely, trubky, PEX trubky",
        "spec_pkg": "Balení",
        "spec_pkg_val": "100 ks (zipový sáček)",
        "specs_desc": "Stačí otočit klip. Ať už pracujete v úzkém nebo širokém kanálu, DuoClips se okamžitě přizpůsobí.",
        "hd_badge": "Extra Strong",
        "hd_title": "DuoClips <span class=\"brand-text-orange\">ORANGE</span> - EXTRA STRONG",
        "hd_subtitle": "Navrženo pro speciální úkoly. Maximální pevnost, když standard nestačí.",
        "hd_feat_1": "Pevnější materiál",
        "hd_feat_2": "Rychlá instalace",
        "hd_feat_3": "Silný úchop",
        "hd_overlay": "Posunout po premiéře",
        "dist_title": "Kontaktujte nás",
        "dist_subtitle": "Máte dotazy? Chcete spolupracovat? Vyplňte níže uvedený formulář.",
        "form_name": "Jméno / Firma",
        "form_placeholder_name": "Jan Novák",
        "form_email": "E-mailová adresa",
        "form_placeholder_email": "kontakt@firma.cz",
        "form_phone": "Telefonní číslo (volitelné)",
        "form_placeholder_phone": "+420 000 000 000",
        "form_terms": "Souhlasím s <a href=\"#\">obchodními podmínkami</a> a <a href=\"#\">zásadami ochrany osobních údajů</a>.",
        "form_consent": "Souhlasím s kontaktováním pro komerční účely.",
        "form_submit": "Odeslat dotaz",
        "form_success": "Zpráva odeslána. Děkujeme!",
        "footer_brand_desc": "Budoucnost profesionální montáže.",
        "footer_contact_title": "B2B Kontakt",
        "footer_work_hours": "Po - Pá 8:00 - 16:00",
        "footer_privacy": "Zásady ochrany osobních údajů",
        "review_title": "Užitečné a snadno použitelné!",
        "review_text": "Perfektní produkt, konečně něco, co je použitelné ve skutečných pracovních podmínkách!!",
        "review_author": "Zákazník Amazonu",
        "review_verified": "✓ Ověřený nákup",
        "review_date": "Recenzováno v Německu 3. května 2026",
        "footer_terms": "Obchodní podmínky",
        "footer_copyright": "&copy; 2026 SCROBER®. Všechna práva vyhrazena.",
        "hd_feat_4": "Pro kabely a trubky",
        "hd_feat_5": "Pro elektrikáře a instalatéry",
        "cart_title": "Váš košík",
        "cart_empty": "Váš košík je prázdný",
        "cart_total": "Celkem:",
        "cart_checkout": "Přejít k pokladně",
        "coll_add_to_cart": "Do košíku",
        "coll_empty": "Žádné produkty v kolekci.",
        "coll_sold_out": "Vyprodáno",
        "form_message": "Zpráva",
        "form_placeholder_message": "Jak vám můžeme pomoci?",
        "pro_cta_buy": "Koupit nyní",
        "prod_add_to_cart": "Do košíku",
        "prod_quantity_label": "Množství",
        "prod_sold_out": "Vyprodáno",
        "prod_variant_label": "Varianta",
        "cart_shipping_free": "Máte dopravu zdarma!",
        "cart_shipping_missing_pre": "Chybí",
        "cart_shipping_missing_post": "do dopravy zdarma!"
    },
    "sl": {
        "nav_product": "Izdelek",
        "nav_specs": "Specifikacije",
        "nav_pro": "Extra Strong",
        "nav_dist": "Kontakt",
        "nav_contact": "Kontakt",
        "hero_badge": "Revolucija v montaži",
        "hero_title_1": "En klik.",
        "hero_title_2": "Veliko možnosti.",
        "hero_subtitle": "Preprosta, bliskovita in neinvazivna montaža kablov. Znebite se vijakov, klinov in lepila.",
        "hero_cta_buy": "Naroči zdaj",
        "shipping_info": "Dostava v 24 urah • GLS",
        "features_title": "Zasnovano za profesionalce",
        "features_subtitle": "Manj orodij. Hitrejše delo. Popolno prileganje.",
        "feat_1_title": "Univerzalna velikost",
        "feat_1_desc": "Od 22 mm do 50 mm. En inovativen sponka nadomesti celoten arzenal tradicionalnih rešitev.",
        "feat_2_title": "Prihranek časa",
        "feat_2_desc": "Samo vstavite v režo in končano. Brez vijakov.",
        "feat_3_title": "100% Izdelano na Danskem",
        "feat_3_desc": "Jamstvo najvišje kakovosti izdelave.",
        "feat_4_title": "Reciklirani materiali",
        "feat_4_desc": "Izdelano iz izjemno trpežnega recikliranega PP materiala.",
        "quote_text": "\"Končno mi ni treba nositi več različnih sponk. En izdelek ustreza vsemu.\"",
        "quote_author": "— Jurij P., Inštalater",
        "specs_title": "Specifikacije.",
        "specs_subtitle": "Vsak detajl je pomemben.",
        "spec_range": "Razpon",
        "spec_material": "Material",
        "spec_material_val": "PP Plastika (Reciklirana)",
        "spec_use": "Uporaba",
        "spec_use_val": "Kabli, cevi, PEX cevi",
        "spec_pkg": "Pakiranje",
        "spec_pkg_val": "100 kosov (vrečka na zadrgo)",
        "specs_desc": "Samo obrnite sponko. Ne glede na to, ali delate v ozkem ali širokem kanalu, se DuoClips takoj prilagodi.",
        "hd_badge": "Extra Strong",
        "hd_title": "DuoClips <span class=\"brand-text-orange\">ORANGE</span> - EXTRA STRONG",
        "hd_subtitle": "Zasnovano za posebne naloge. Največja trdnost, ko standard ni dovolj.",
        "hd_feat_1": "Močnejši material",
        "hd_feat_2": "Hitra namestitev",
        "hd_feat_3": "Močan oprijem",
        "hd_overlay": "Pomaknite se po premieri",
        "dist_title": "Kontaktirajte nas",
        "dist_subtitle": "Imate vprašanja? Želite sodelovati? Izpolnite spodnji obrazec.",
        "form_name": "Ime / Podjetje",
        "form_placeholder_name": "Janez Novak",
        "form_email": "E-poštni naslov",
        "form_placeholder_email": "kontakt@podjetje.si",
        "form_phone": "Telefonska številka (neobvezno)",
        "form_placeholder_phone": "+386 00 000 000",
        "form_terms": "Sprejemam <a href=\"#\">Pogoje poslovanja</a> in <a href=\"#\">Politiko zasebnosti</a>.",
        "form_consent": "Strinjam se s kontaktiranjem v komercialne namene.",
        "form_submit": "Pošlji povpraševanje",
        "form_success": "Sporočilo poslano. Hvala!",
        "footer_brand_desc": "Prihodnost profesionalne montaže.",
        "footer_contact_title": "B2B Kontakt",
        "footer_work_hours": "Pon - Pet 8:00 - 16:00",
        "footer_privacy": "Politika zasebnosti",
        "review_title": "Koristno in enostavno za uporabo!",
        "review_text": "Popoln izdelek, končno nekaj, kar je uporabno v resničnih delovnih pogojih!!",
        "review_author": "Kupec na Amazonu",
        "review_verified": "✓ Preverjen nakup",
        "review_date": "Ocenjeno v Nemčiji, 3. maja 2026",
        "footer_terms": "Pogoji uporabe",
        "footer_copyright": "&copy; 2026 SCROBER®. Vse pravice pridržane.",
        "hd_feat_4": "Za kable in cevi",
        "hd_feat_5": "Za električarje in vodovodarje",
        "cart_title": "Vaša košarica",
        "cart_empty": "Vaša košarica je prazna",
        "cart_total": "Skupaj:",
        "cart_checkout": "Na blagajno",
        "coll_add_to_cart": "V košarico",
        "coll_empty": "Ni izdelkov v zbirki.",
        "coll_sold_out": "Razprodano",
        "form_message": "Sporočilo",
        "form_placeholder_message": "Kako vam lahko pomagamo?",
        "pro_cta_buy": "Kupi zdaj",
        "prod_add_to_cart": "V košarico",
        "prod_quantity_label": "Količina",
        "prod_sold_out": "Razprodano",
        "prod_variant_label": "Različica",
        "cart_shipping_free": "Imate brezplačno dostavo!",
        "cart_shipping_missing_pre": "Do brezplačne dostave vam manjka še",
        "cart_shipping_missing_post": "!"
    }
};

const allLangs = ['it','pt','nl','sv','da','no','fi','sk','hu','ro','bg','el','hr','sr','lt','lv','et','uk','ru','is','ga','mt','sq'];
allLangs.forEach(lang => {
    translations[lang] = { ...translations['en'] };
});

window.getTranslation = function(key) {
    const lang = localStorage.getItem('duoclips_lang') || 'pl';
    const dict = translations[lang] || translations['en'];
    return dict[key] || key;
};
